import { useNavigate } from 'react-router';
import * as R from '@/Router/routes';
import { Application } from '@/api/getClientApplication';
import { shouldNavigateToUploadKyc } from '@/pages/UploadKYC/useUploadKYC';

function useNavigateWithLoanConfirmResolution() {
  const navigate = useNavigate();
  function navigateWithLoanConfirmResolution(
    application: Application,
    isNotRepeatedLoan: boolean,
  ) {
    if (
      application &&
      ((application.resolution === 'MANUAL' &&
        application.resolutionDetail === 'SOLVENCY' &&
        application.resolutionMessage === 'ASK_FOR_DOCUMENTS') ||
        (application.resolution === 'MANUAL' &&
          application.resolutionDetail === 'INSUFFICIENT_PSD2_INCOME'))
    ) {
      navigate(R.DOCUMENT_UPLOAD);
      return;
    }

    // NOTE: Check if client is required to upload ID Documents
    if (shouldNavigateToUploadKyc(application)) {
      navigate(R.KYC_UPLOAD);
      return;
    }

    // NOTE: Check if loan application is approved and client confirmed the application
    if (
      application &&
      application.resolution === 'APPROVED' &&
      application.confirmed
    ) {
      if (isNotRepeatedLoan) {
        navigate(R.ADDITIONAL_AMOUNT_APPROVED);
        return;
      }

      navigate(R.LOAN_APPROVED);
    }
  }

  return { navigateWithLoanConfirmResolution };
}

export default useNavigateWithLoanConfirmResolution;
